/**
 * @ngdoc controllers
 * @memberof mercury.modules.settings.company
 * @name SettingsCompanyOutletsAddCtrl
 */
angular.module('mercury.modules.settings.company')
.controller('SettingsCompanyOutletsAddCtrl', ["dialog", "companyId", "$scope", "Outlets", function(dialog, companyId, $scope, Outlets) {
  $scope.loading = Outlets.getAvailable(companyId);
  $scope.loading.then(function(result) {
    $scope.outlets = result;
  });

  $scope.addOutlet = function(newOutlet) {
    $scope.savingOutlet = Outlets.add(companyId, newOutlet);
    $scope.savingOutlet.then(function() {
      $scope.$close(newOutlet);
    });
  };
}]);
